/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

export type Product = {
    /**
     * Type of product, to know in which resource to look for product ID.
     */
    type: Product.type;
    /**
     * Internal identification of product.
     */
    id: string;
};

export namespace Product {

    /**
     * Type of product, to know in which resource to look for product ID.
     */
    export enum type {
        ACCOUNTS = 'ACCOUNTS',
    }


}

